const Marionette = require('lib/marionette')
const ButtonView = require('./button_view')
const log = require('log').create('button'); // eslint-disable-line

const ButtonListView = Marionette.CollectionView.extend({

    displayName: 'ButtonListView',

    className: 'buttons large',

    childView: ButtonView,

    childViewEventPrefix: 'button',

})

module.exports = ButtonListView
